// test1947
(1947 && 0);
